module.exports = __webpack_public_path__ + "img/store-shopify.74a0f8aa.svg";